"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemarkableCityIcon = RemarkableCityIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function RemarkableCityIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.0977 18.1956V6.50109H17.3241C16.8922 3.95301 14.6704 2 12.0024 2C9.33443 2 7.10771 3.94827 6.6807 6.50109H3.90216V18.1956H3V19.9951H8.39861V11.8998H15.5967V20H20.9953V18.1957L20.0977 18.1956Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.2422 13.639H13.7578V19.7938H10.2422V13.639Z",
    fill: "currentColor"
  }));
}